import * as React from "react";
import { buildStateProvider, StateChunk } from "@shared-ui/provided-state-context";
import { TripsHeroStateProviderEvents } from "@shared-ui/trips-lists";

export type TripsHeroState = {
  isRendered: boolean;
};

export class TripsHeroStateChunk implements StateChunk<TripsHeroState> {
  public data: TripsHeroState = { isRendered: false };

  public stateFieldName = "tripsHero";

  public events: string[] = [TripsHeroStateProviderEvents.RENDER];

  public update(event: string, currentState: TripsHeroState): TripsHeroState {
    return { ...currentState, isRendered: true };
  }
}

const StateProvider = buildStateProvider(new TripsHeroStateChunk());

export const TripsHeroProvider: React.FC = ({ children }) => {
  return <StateProvider>{children}</StateProvider>;
};
